import { render, staticRenderFns } from "./ViewSlipModal.vue?vue&type=template&id=e64b5172&"
import script from "./ViewSlipModal.vue?vue&type=script&lang=js&"
export * from "./ViewSlipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports